import { styled } from '@material-ui/core';
import { Grid, Typography } from '@mui/material';
import * as React from 'react';
import service from '../../../apis/service';
import { apiEndpoints } from '../../../constants/apiEndpoints';
import { ErrorToast, notifySuccess } from '../../utils/Utils';
import { showProgress } from '../../../redux/actions/DealershipActions';
import ConfirmationDialog from '../../common/ConfirmationDialog';
import { ReactComponent as FireIcon } from '../../../assets/fire.svg';

const HighestStreak = ({ hash, current, highest, getEmp }) => {
  const [openDeleteConfirm, setOpenDeleteConfirm] = React.useState(false);
  const handleConfirm = async () => {
    try {
      if (current === highest) {
        ErrorToast('User’s current streak is equal to highest streak');
        return;
      }
      if (current > highest) {
        ErrorToast('User’s current streak is greater than highest streak');
        return;
      }
      showProgress(true);
      await service.post(apiEndpoints.DEALER_EMPLOYEE_RESTORE_HIGHEST_STREAK.replace('ID', hash));
      notifySuccess('Streak restored successfully.');
      getEmp();
    } catch (e) {
      ErrorToast(e);
    } finally {
      setOpenDeleteConfirm(false);
      showProgress(false);
    }
  };

  const handleRestoreStreak = async () => setOpenDeleteConfirm(true);
  const handleDeleteConfirmClose = () => setOpenDeleteConfirm(false);

  return (
    <MainGrid container direction="column">
      <Grid item>
        <Grid container direction="row" spacing={1}>
          <Grid item>
            <StyledTypography>Current Streak</StyledTypography>
          </Grid>
          <Grid item>
            <StyledValueTypography>{current}</StyledValueTypography>
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        <Grid container direction="row" spacing={1}>
          <Grid item>
            <StyledTypography>Highest Streak</StyledTypography>
          </Grid>
          <Grid item>
            <StyledValueTypography>{highest}</StyledValueTypography>
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        <Grid container direction="row">
          <Grid item onClick={current < highest ? handleRestoreStreak : null}>
            <StyledLinkTypography $disabled={current >= highest}>Restore Highest Streak</StyledLinkTypography>
          </Grid>
        </Grid>
      </Grid>
      <ConfirmationDialog
        title="Are you sure you want to restore the highest streak?"
        onClose={handleDeleteConfirmClose}
        isOpen={openDeleteConfirm}
        confirmFn={handleConfirm}
        disagreeText="Cancel"
        agreeText="Restore"
        Icon={FireIcon}
        width="335px"
        height="229px"
      />
    </MainGrid>
  );
};
export default HighestStreak;

const MainGrid = styled(Grid)(() => ({
  margin: '20px !important',
}));

const StyledTypography = styled(Typography)(() => ({
  fontFamily: 'Lato !important',
  fontWeight: '500 !important',
  fontSize: '12px !important',
  lineHeight: '140% !important',
  color: '#667085 !important',
}));

const StyledValueTypography = styled(Typography)(() => ({
  fontFamily: 'Lato !important',
  fontWeight: '600 !important',
  fontSize: '12px !important',
  lineHeight: '140% !important',
}));

const StyledLinkTypography = styled(Typography)(({ $disabled }) => ({
  fontSize: '14px !important',
  fontFamily: 'Lato !important',
  fontWeight: '500 !important',
  lineHeight: '20px !important',
  letterSpacing: '0px !important',
  textDecoration: 'underline',
  textDecorationStyle: 'solid',
  textDecorationOffset: '2px',
  textDecorationThickness: '1px',
  color: $disabled ? '#BDBDBD' : '#622FEE',
  cursor: $disabled ? 'not-allowed' : 'pointer',
  pointerEvents: $disabled ? 'none' : 'auto',
}));
